import { Nav } from "@/components/marketing/Nav";
import { CtaFooter } from "@/components/marketing/CtaFooter";

const rows = [
  ["cvi_cookie_consent", "This website", "Stores your cookie preferences", "12 months"],
  ["scd_token", "This website", "Keeps verified specialists signed in to the portal", "12 hours"],
];

export default function Cookies() {
  return (
    <div className="bg-ivory min-h-screen" data-testid="cookies-page">
      <Nav />
      <div className="pt-32 pb-24 max-w-3xl mx-auto px-6">
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">Legal</p>
        <h1 className="font-serif text-3xl lg:text-4xl font-semibold text-navy mb-10">Cookie policy</h1>
        <p className="text-sm text-navy/60 leading-relaxed mb-10">
          Not all cookies (or biscuits) are unhealthy. We use a small number of cookies to
          keep the site secure and understand how it is used. You can change your choices at
          any time using the cookie preferences option shown when you first visit.
        </p>

        <div className="border border-navy/10" data-testid="cookie-table">
          <div className="grid grid-cols-4 gap-px bg-navy/10 font-mono text-[10px] tracking-[0.2em] uppercase text-navy/50">
            {["Cookie", "Provider", "Purpose", "Expiry"].map((h) => (
              <div key={h} className="bg-ivory px-4 py-3">{h}</div>
            ))}
          </div>
          {rows.map((r) => (
            <div key={r[0]} className="grid grid-cols-4 gap-px bg-navy/10 border-t border-navy/10">
              {r.map((cell, i) => (
                <div key={i} className="bg-white px-4 py-3 text-xs text-navy/70">{cell}</div>
              ))}
            </div>
          ))}
        </div>

        <div className="border-t border-navy/10 mt-10 pt-6">
          <h2 className="font-serif text-xl font-semibold text-navy mb-3">Managing cookies</h2>
          <p className="text-sm text-navy/60 leading-relaxed">
            You can accept or reject non-essential cookies via the consent banner, and you can
            delete cookies at any time through your browser settings. Rejecting non-essential
            cookies will not affect your access to the site or the specialist portal.
          </p>
        </div>
      </div>
      <CtaFooter />
    </div>
  );
}
